import { makeAutoObservable } from "mobx";
import { PhoneNumber } from "../PhoneNumber";
import { FullName } from "./FullName";
/**
 * Contact details for voice ordering.
 * Stores the caller's phone number, plus a name where the agent asks for one
 * (Croatia) - no email required.
 */
export class VoiceOrderContactDetails {
    constructor(params) {
        this.type = "VoiceOrder";
        this.contactDetailsLock = params.contactDetailsLock;
        this.fullName = FullName.empty();
        this._phone = params.phone;
        makeAutoObservable(this);
    }
    static empty(validatePhoneService, contactDetailsLock) {
        return new VoiceOrderContactDetails({
            contactDetailsLock,
            phone: PhoneNumber.empty(validatePhoneService),
        });
    }
    static fromStorageData({ validatePhoneService, contactDetailsLock, storageData, }) {
        return new VoiceOrderContactDetails({
            contactDetailsLock,
            phone: new PhoneNumber({
                validatePhoneService,
                country: storageData.phoneCountry,
                value: storageData.phoneNumber,
            }),
        });
    }
    setData(data) {
        if (this.locked)
            return;
        if (data.phone !== undefined) {
            this.setPhone(data.phone.value, data.phone.country);
        }
    }
    get phone() {
        return this._phone;
    }
    setPhone(value, country) {
        if (this.locked) {
            throw new Error("Can't change phone number, ContactDetails locked");
        }
        this._phone.value = value;
        this._phone.country = country;
    }
    get email() {
        throw new Error("Can't access email at VoiceOrderContactDetails");
    }
    set email(_) {
        throw new Error("Can't set email at VoiceOrderContactDetails");
    }
    get locked() {
        return this.contactDetailsLock.locked;
    }
    unlock() {
        this.contactDetailsLock.unlock();
    }
    /**
     * Phone only, deliberately: `FullName.availability` reports `FullNameMissing`
     * for the empty name every non-HR call carries, and `InvalidFullName` for a
     * one-word first name - either would make the whole order unavailable.
     */
    get availability() {
        return this._phone.availability;
    }
    get storageData() {
        return {
            type: "VoiceOrder",
            phoneNumber: this._phone.value,
            phoneCountry: this._phone.country,
        };
    }
}
